// extracted by mini-css-extract-plugin
export default {"experience-info":"styles_experience-info__j9oRW","experience-content":"styles_experience-content__ECZFF"};